import {Product} from "./product";
import {ProductSize} from "./ProductSize";
import {ProductColor} from "./productColor";

export class ProductBarcode {

    id?: string;
    barcode?: string = '';
    product?: Product;
    size?: ProductSize;
    color?: ProductColor;
    productId?: string | null | undefined;
    sizeId?: string;
    colorId?: string;
    movements?: string;
    companyId?: string = '';
    stockQuantity?: number;
    quantity?: number;
    createdAt?: Date;


    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.barcode = raw.barcode;
            this.product = raw.product;
            this.size = raw.size;
            this.color = raw.color;
            this.productId = raw.productId;
            this.sizeId = raw.sizeId;
            this.colorId = raw.colorId;
            this.movements = raw.movements;
            this.stockQuantity = raw.stockQuantity;
            this.companyId = raw.companyId;
            this.createdAt = raw.createdAt;
        }
    }
}
